module.exports = "/assets/c0c07b4aad8266bea819e2cd498932fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/Y4.png
// module id = 3134
// module chunks = 0